import { Box, Tab, Tabs } from '@mui/material';
import { useStore } from 'mobx/StoreContext';
import { observer } from 'mobx-react-lite';
import {
  JobAssignStatus,
  JobQueueTableType,
} from 'pages/iPriseV2/common/enum/TeamUserRoles';
import CommonJobQueueTable from 'pages/iPriseV2/common/JobQueueTable';
import React from 'react';

import ColumnsSidebar from './ColumnsSidebar';

const JobQueueTable: React.FC = () => {
  const { teamLeadJobQueueService } = useStore();
  const {
    subTab,
    newPage,
    newRowsPerPage,
    assignedPage,
    assignedRowsPerPage,
    readyForReviewPage,
    readyForReviewRowsPerPage,
    approvedPage,
    approvedRowsPerPage,
    selectedSort,
    selectedTeam,
    searchTerm,
    percentage,
  } = teamLeadJobQueueService;

  const handleSubTabChange = (
    _event: React.SyntheticEvent,
    newValue: number,
  ) => {
    teamLeadJobQueueService.setSubTab(newValue);
  };

  return (
    <Box className="table-container-with-sidebar">
      <Box className="table-main-content">
        <Box className="sub-tabs-container">
          <Box className="sub-tabs-wrapper">
            <Tabs
              value={subTab}
              onChange={handleSubTabChange}
              className="sub-tabs"
              variant="scrollable"
              allowScrollButtonsMobile
              TabIndicatorProps={{
                className: 'sub-tab-indicator',
              }}>
              <Tab label="New" className="sub-tab" />
              <Tab label="Assigned" className="sub-tab" />
              <Tab label="Ready for Review" className="sub-tab" />
              <Tab label="Approved" className="sub-tab" />
            </Tabs>
          </Box>
        </Box>

        {subTab === 0 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.TEAM_LEAD_NEW}
            status={JobAssignStatus.TL_ASSIGNED}
            queryKey="tl-job-postings-new"
            page={newPage}
            rowsPerPage={newRowsPerPage}
            onPageChange={(p) => teamLeadJobQueueService.setNewPage(p)}
            onRowsPerPageChange={(r) =>
              teamLeadJobQueueService.setNewRowsPerPage(r)
            }
            popperId="skills-popper-tl-new"
            selectedSort={selectedSort}
            selectedTeam={selectedTeam}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
        {subTab === 1 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.TEAM_LEAD_ASSIGNED}
            status={`${JobAssignStatus.RECRUITER_ASSIGNED},${JobAssignStatus.RECRUITER_ACCEPTED}`}
            queryKey="tl-job-postings-assigned"
            page={assignedPage}
            rowsPerPage={assignedRowsPerPage}
            onPageChange={(p) => teamLeadJobQueueService.setAssignedPage(p)}
            onRowsPerPageChange={(r) =>
              teamLeadJobQueueService.setAssignedRowsPerPage(r)
            }
            popperId="skills-popper-tl-assigned"
            selectedSort={selectedSort}
            selectedTeam={selectedTeam}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
        {subTab === 2 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.TEAM_LEAD_READY_FOR_REVIEW}
            status={JobAssignStatus.READY_FOR_REVIEW}
            queryKey="tl-job-postings-ready-for-review"
            page={readyForReviewPage}
            rowsPerPage={readyForReviewRowsPerPage}
            onPageChange={(p) =>
              teamLeadJobQueueService.setReadyForReviewPage(p)
            }
            onRowsPerPageChange={(r) =>
              teamLeadJobQueueService.setReadyForReviewRowsPerPage(r)
            }
            popperId="skills-popper-tl-ready"
            selectedSort={selectedSort}
            selectedTeam={selectedTeam}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
        {subTab === 3 && (
          <CommonJobQueueTable
            tableType={JobQueueTableType.TEAM_LEAD_APPROVED}
            status={JobAssignStatus.TL_APPROVED}
            queryKey="tl-job-postings-approved"
            page={approvedPage}
            rowsPerPage={approvedRowsPerPage}
            onPageChange={(p) => teamLeadJobQueueService.setApprovedPage(p)}
            onRowsPerPageChange={(r) =>
              teamLeadJobQueueService.setApprovedRowsPerPage(r)
            }
            popperId="skills-popper-tl-approved"
            selectedSort={selectedSort}
            selectedTeam={selectedTeam}
            searchTerm={searchTerm}
            percentage={percentage}
          />
        )}
      </Box>
      <ColumnsSidebar />
    </Box>
  );
};

export default observer(JobQueueTable);
